import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
  style?: object;
};
function ToolsMedium({
  size = 16,
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color} style={style}><path d="M4.92 21.96c.768 0 1.488-.288 2.04-.84l8.976-9c.384.072.744.12 1.104.12 2.904 0 5.28-2.376 5.28-5.28 0-2.904-2.376-5.28-5.28-5.28-2.904 0-5.28 2.376-5.28 5.28 0 .36.048.72.12 1.104l-9 8.976a2.849 2.849 0 00-.84 2.04 2.888 2.888 0 002.88 2.88zM1.68 6l4.848 4.848 2.16-2.16-.744-.744-.984.96-1.056-1.056.96-.984-.768-.768-.984.96L4.056 6 6 4.056l3.672 3.672.312-.312c-.048-.864 0-1.272.072-1.68L6 1.68 1.68 6zm2.16 13.08c0-.288.096-.552.312-.768l9.792-9.768a3.508 3.508 0 01-.384-1.584c0-1.92 1.56-3.48 3.48-3.48.6 0 1.176.168 1.68.432L16.2 6.456 17.544 7.8l2.544-2.52a3.64 3.64 0 01.432 1.68c0 1.92-1.56 3.48-3.48 3.48a3.508 3.508 0 01-1.584-.384l-9.768 9.792a1.05 1.05 0 01-.768.312c-.6 0-1.08-.48-1.08-1.08zm9.312-1.608L18 22.32 22.32 18l-4.056-4.056c-.408.072-.816.12-1.68.072l-.312.312L19.944 18 18 19.944l-1.056-1.056.96-.984-.768-.768-.984.96-1.056-1.056.96-.984-.744-.744-2.16 2.16z"  /></Svg>;
}
export default ToolsMedium;